import { Badge, BadgeId } from "@/app/@types";

  // Badge system with NFT-ready metadata
 export const badgeSystem: Record<BadgeId, Badge> = {
    // Beginner Badges (Bronze NFTs)
    'first-challenge': {
      name: 'First Steps',
      emoji: '🎯',
      description: 'Completed your first behavioral economics challenge',
      rarity: 'Common',
      points: 50,
      nftMetadata: {
        background: 'gradient-bronze',
        trait: 'Beginner',
        power: 1
      }
    },
    'system-1-survivor': {
      name: 'System 1 Survivor',
      emoji: '🧠',
      description: 'Correctly answered Kahneman\'s bat & ball puzzle',
      rarity: 'Common',
      points: 75,
      nftMetadata: {
        background: 'gradient-bronze',
        trait: 'Kahneman Scholar',
        power: 2
      }
    },
    
    // Intermediate Badges (Silver NFTs)
    'crowd-beater': {
      name: 'Crowd Beater',
      emoji: '⚔️',
      description: 'Beat the crowd 5 times in a row',
      rarity: 'Uncommon',
      points: 200,
      nftMetadata: {
        background: 'gradient-silver',
        trait: 'Independent Thinker',
        power: 5
      }
    },
    'bias-slayer': {
      name: 'Bias Slayer',
      emoji: '🗡️',
      description: 'Correctly identified cognitive biases in 10 different challenges',
      rarity: 'Uncommon',
      points: 300,
      nftMetadata: {
        background: 'gradient-silver',
        trait: 'Cognitive Warrior',
        power: 7
      }
    },
    'streak-master': {
      name: 'Streak Master',
      emoji: '🔥',
      description: 'Maintained a 10-day prediction streak',
      rarity: 'Uncommon',
      points: 250,
      nftMetadata: {
        background: 'gradient-silver',
        trait: 'Consistent Predictor',
        power: 6
      }
    },
    
    // Advanced Badges (Gold NFTs)
    'perfect-calibration': {
      name: 'Perfect Calibration',
      emoji: '🎯',
      description: 'Achieved 90%+ accuracy on 20 probability estimates',
      rarity: 'Rare',
      points: 500,
      nftMetadata: {
        background: 'gradient-gold',
        trait: 'Master Calibrator',
        power: 10
      }
    },
    'thaler-scholar': {
      name: 'Thaler Scholar',
      emoji: '🏆',
      description: 'Mastered all endowment effect and nudge theory challenges',
      rarity: 'Rare',
      points: 400,
      nftMetadata: {
        background: 'gradient-gold',
        trait: 'Behavioral Expert',
        power: 8
      }
    },
    'market-prophet': {
      name: 'Market Prophet',
      emoji: '🔮',
      description: 'Correctly predicted 5 live market outcomes',
      rarity: 'Rare',
      points: 600,
      nftMetadata: {
        background: 'gradient-gold',
        trait: 'Future Seer',
        power: 12
      }
    },
    
    // Legendary Badges (Diamond NFTs)
    'nobel-laureate': {
      name: 'Nobel Laureate',
      emoji: '🏅',
      description: 'Reached top 1% globally in behavioral economics mastery',
      rarity: 'Legendary',
      points: 1000,
      nftMetadata: {
        background: 'gradient-diamond',
        trait: 'Legendary Scholar',
        power: 20,
        special: 'Animated'
      }
    },
    'grand-master': {
      name: 'Grand Master',
      emoji: '👑',
      description: 'Earned all other badges and maintained #1 rank for 30 days',
      rarity: 'Mythic',
      points: 2000,
      nftMetadata: {
        background: 'gradient-mythic',
        trait: 'Ultimate Predictor',
        power: 50,
        special: 'Ultra-Rare Animated'
      }
    },

    // Behavioral Finance Challenge Path Badges
    'disciplined-trader': {
      name: 'Disciplined Trader',
      emoji: '🎯',
      description: 'Completed Rookie Trader Academy - survived first trades without blowing up',
      rarity: 'Rare',
      points: 500,
      nftMetadata: {
        background: 'gradient-gold',
        trait: 'Risk Manager',
        power: 12
      }
    },
    'market-historian': {
      name: 'Market Historian',
      emoji: '🏛️',
      description: 'Completed Wall Street Legends - learned from the greatest (and their mistakes)',
      rarity: 'Rare',
      points: 500,
      nftMetadata: {
        background: 'gradient-gold',
        trait: 'Wisdom Keeper',
        power: 12
      }
    },
    'sharp-bettor': {
      name: 'Sharp Bettor',
      emoji: '🏈',
      description: 'Completed Sports Betting Psychology - mastered the mental game',
      rarity: 'Rare',
      points: 500,
      nftMetadata: {
        background: 'gradient-gold',
        trait: 'Edge Hunter',
        power: 12
      }
    },
    'diamond-hands': {
      name: 'Diamond Hands',
      emoji: '💎',
      description: 'Completed Crypto Casino - survived the wild west of digital assets',
      rarity: 'Rare',
      points: 500,
      nftMetadata: {
        background: 'gradient-gold',
        trait: 'HODL Master',
        power: 12
      }
    },
    'crisis-alpha': {
      name: 'Crisis Alpha',
      emoji: '📉',
      description: 'Completed Market Crash Survival - thrives when others panic',
      rarity: 'Rare',
      points: 500,
      nftMetadata: {
        background: 'gradient-gold',
        trait: 'Contrarian',
        power: 12
      }
    },
    'volatility-hunter': {
      name: 'Volatility Hunter',
      emoji: '🎲',
      description: 'Completed Options Assassin - masters the most dangerous weapons in finance',
      rarity: 'Rare',
      points: 500,
      nftMetadata: {
        background: 'gradient-gold',
        trait: 'Options Warrior',
        power: 12
      }
    }
  }